import {
	Component,
	OnInit,
	ViewChild,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	HostListener,
	ViewChildren,
	ViewRef,
	ElementRef,
	Inject
} from '@angular/core';
import {trigger, transition, style, animate,} from "@angular/animations";
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import moment from 'moment';
// Material
import { MatPaginator, MatSort, MatDialog, MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { tap } from 'rxjs/operators';
import { merge, BehaviorSubject, ReplaySubject } from 'rxjs';
//Datasourcea 
import { KeHoachSanXuatDataSource } from '../../../san-xuat/ke-hoach-san-xuat/ke-hoach-san-xuat-datasource/ke-hoach-san-xuat.datasource';
//Service 
import { DungChungService } from './../../../dung-chung/__services/dung-chung.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, QueryParamsModel, MessageType } from '../../../../../../core/_base/crud';
import { GhiNhanKQSXPhongCanService } from '../ghi-nhan-kqsx-phong-can-service/ghi-nhan-kqsx-phong-can.service';
//Model
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { LsxphongCanKetQuaSx } from '../ghi-nhan-kqsx-phong-can-model/ghi-nhan-kqsx-phong-can.model';
import { TokenStorage } from 'app/core/auth/_services';
import { DeNghiNhapKhoDetailDialogComponent } from '../../../chuc-nang-kho-page/kho-de-nghi-nhap-kho-page/kho-de-nghi-nhap-kho-detail-dialog/kho-de-nghi-nhap-kho-detail-dialog.component';
import { DeNghiNhapKhoService } from '../../../chuc-nang-kho-page/kho-de-nghi-nhap-kho-page/kho-de-nghi-nhap-kho-page-service/kho-de-nghi-nhap-kho-page.service';

@Component({
	selector: 'kt-chi-tiet-kqsx-phong-can',
	templateUrl: './chi-tiet-kqsx-phong-can.component.html',
	styleUrls: ['../ghi-nhan-kqsx-phong-can.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe],
	animations: [
		trigger(
		  'collapseAnimation', [
			transition(':enter', [
			  style({transform: 'translateX(100%)', opacity: 0}),
			  animate('800ms', style({transform: 'translateX(0)', opacity: 1, 'overflow-x': 'hidden'}))
			]),
			transition(':leave', [
			  style({transform: 'translateX(0)', opacity: 1}),
			  animate('800ms', style({transform: 'translateX(100%)', opacity: 0}))
			])
		  ]
		),
	]
})
export class ChiTietKQSXPhongCanComponent implements OnInit {

	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/


	/* ------------------------------ ROLE ------------------------------*/
	LIST_ROLES_USER: [] = [];
	/* ------------------------------------------------------------------*/


	/*---------------------- Thông tin thao tác cho phiếu --------------- */
	item: LsxphongCanKetQuaSx;
	dataBOM: LsxphongCanKetQuaSx[] = [];
	toDate: any
	ceilSoMe: number = 0;
	sttSoMe: number[] = [];
	/* ------------------------------------------------------------------*/


	/* ------------------- Các form trên dialog --------------------------*/
	KiemTraForm: FormGroup;
	/* ------------------------------------------------------------------ */

	
	/*------------------------- Extend field: ----------------------------*/
	minDate: any;
	fixedPoint = 2;
	openDialog: boolean = false;
	keywordsearch: string = '';
	previousIndex: number;
	disableButton: boolean = false;
	disableButtonDuyet: boolean = false;
	isChange: boolean = false;
	isCollapsed : boolean = false;
	/* ------------------------------------------------------------------*/


	constructor(
		public dialogRef: MatDialogRef<ChiTietKQSXPhongCanComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private services: GhiNhanKQSXPhongCanService,
		private deNghiNhapKhoService: DeNghiNhapKhoService,
		private dungChungServices: DungChungService,
		public dialog: MatDialog,
		private tokenStorage: TokenStorage,
		private builder: FormBuilder,
		private router: Router,
		private datePipe: DatePipe,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private commonServices: DungChungService,
	) {
		this.dialogRef.disableClose = true;
		let user = JSON.parse(localStorage.getItem("UserInfo"));
		this.LIST_ROLES_USER = user.roles;
	}

	/*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.item = this.data.dataMain;
		this.dataBOM = this.data.dataBOM;
		this.toDate = moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		if(this.item != null){
			this.ceilSoMe = Math.ceil(this.item.SoLuongMeTronThucTe);
		}
		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
			this.changeDetectView();
		});
		this.createForm();
		this.changeDetectView();
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------- CÁC THAO TÁC TRÊN FORM ----------------------*/
	back() {
		this.dialogRef.close(
			{ 
				isChange: this.isChange,		
				result : this.item,
			}
		);
	}
	createForm(){
		var tenNguoiLap = '';
        this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
		
		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });

		this.KiemTraForm = this.builder.group({
            NguoiXacNhan: [this.getHistory(2)],
            NgayXacNhan: [this.getHistory(3)],
			KetQUaDuyet: [this.getHistory(0)],
			LyDo: [this.getHistory(1)]
		})

		this.toDate = this.getHistory(3);
		this.KiemTraForm.disable();

		this.changeDetectView();
	}

	changeKetQua(){
		if(+this.KiemTraForm.controls["KetQUaDuyet"].value == 2){
			this.KiemTraForm.controls["LyDo"].setValidators([Validators.required]);
			this.KiemTraForm.controls['LyDo'].updateValueAndValidity()
		}
		else if(+this.KiemTraForm.controls["KetQUaDuyet"].value == 1){
			this.KiemTraForm.controls["LyDo"].setValidators([]);
			this.KiemTraForm.controls['LyDo'].updateValueAndValidity()
		}
	}
	isKhongDat(){
		return +this.KiemTraForm.controls["KetQUaDuyet"].value == 2;
	}

	getHistory(type: number){
		if(this.item != null && this.item.listLsxphongCanKetQuaSxLsThaoTac != null){
			let item = this.item.listLsxphongCanKetQuaSxLsThaoTac.find(x =>  x.LoaiThaoTac == LsxphongCanKetQuaSx.optionsTinhTrang[5].value)
			if(item == null){
				item = this.item.listLsxphongCanKetQuaSxLsThaoTac.find(x =>  x.LoaiThaoTac == LsxphongCanKetQuaSx.optionsTinhTrang[4].value)
			}
	
			if(item != null && type == 0){
				return item.NoiDung == "True" ? "1" : "2"
			}
			else if(item != null && type == 1){
				return item.GhiChu;
			}
			else if(item != null && type == 2){
				return item.TenNguoiThaoTac;
			}
			else if(item != null && type == 3){
				return this.getFormatDate(item.NgayThaoTac);
			}
		}
		return '';
	}

	OnOffCollapse(){
		if(this.sttSoMe.length == 0){
			for(var i = 0; i < this.ceilSoMe; i++){
				this.sttSoMe.push(i);
			}
		}
		else{
			this.sttSoMe = [];
		}
		this.changeDetectView();
	}
	open_dialog_detail(__iddn: number) {
		this.openDialog = true;
		this.deNghiNhapKhoService.getItemById(__iddn).subscribe(res => {
			if (res.status == 1) {
				const dialogRef = this.dialog.open(DeNghiNhapKhoDetailDialogComponent, {
					data: {
						data: res.data,
						canEdit: false
					},
					maxHeight: '90vh',
					width: '90vw'
				});
				dialogRef.afterClosed().subscribe(res => {
					setTimeout(() => {
						this.openDialog = false;
					}, 50);
				});
			} else {
				this.openDialog = false;
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	/* -----------------------------------------------------------------------*/


	/*----------------------- CÁC HÀM SỰ KIỆN FOCUS --------------------------*/
	forcusEvents() {
		this.openDialog = false;
		this.changeDetectView();
	}
	disabledDialog() {
		this.openDialog = true;
		this.changeDetectView();
	}
	checkDashboardRoute() {
		/* 
			Kiểm tra xem có phải đang ở dashboard không, nếu là trang dashboard thì không thực hiện
			các action trên component hiện tại.
		*/
		if (this.router.url === '/')
			return true;
		return false;
	}
	/* -----------------------------------------------------------------------*/


	/*-------------------- HÀM HỖ TRỢ FORMAT DẠNG SỐ -----------------------*/
	showErrorInputSL(columnName: string, formGroup: any, name: string) {
		let message = "";
		let controls = formGroup.controls;
		if (controls[columnName].value.length == 0 || this.formatComparenumber(controls[columnName].value) == 0) return name + ' là bắt buộc';
		if (controls[columnName].hasError('maxlength')
			|| (controls[columnName].value.length > 22
				&& (controls[columnName].value.indexOf(',') == 0 || controls[columnName].value.indexOf(',') > 21)))
			return 'Tối đa 18 chữ số với 2 chữ số thập phân';
		return message;
	}
	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == ',') {
					count += 1;
				}
			}
		}
		else {
			event = "" + event
			for (let i = 0; i < event.length; i++) {
				if (event[i] == ',') {
					count += 1;
				}
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		if (typeof (item) === "string") {
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	formatComparenumber(number: string) {
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER(item);
	}
	keyUpInputNumberVND(event) {
		FunctionPublic.preventAlphaV2(event);
	}
	changeInputNumberVND(event, columnName, min: number = 0, formGroup) {
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

			let data = FunctionPublic.slListChangedV2(event);
			if (data) {
				if (this.f_number(data) < min && event.data && event.data == '0') data = this.f_number((min));
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;

				if (data.length == 4) {
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}

			} else {
				controls[columnName].setValue(this.f_number((min)));
			}
		}
	}
	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup) {
		let controls = formGroup.controls;
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");

			if (Number(tmpValue) < min) tmpValue = min;

			if (!controls[controlName].invalid) {
				controls[controlName].setValue(
					this.f_number((tmpValue))
				);
			}
			if (tmpValue.indexOf(',') == 0 && tmpValue.length == 1) {
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_number((tmpValue))
			);
		}
		else {
			controls[controlName].setValue(this.f_number((min)));
		}
	}
	changeInputNumberVNDInList(event: any, min: number = 0) {

		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

			let data = FunctionPublic.slListChangedV2(event);
			console.log(data)
			if (data) {
				if (this.f_number(data) < min && event.data && event.data == '0') data = this.f_number(min);
				event.target.value = data;
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				if (data.length == 4) {
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}
			} else {
				event.target.value = this.f_number((min));
			}
		}
	}
	changeInputOfFormVNDInList(columnName: string, event: any, min: number = 0, item: any) {

		if (event.target.value == "") {
			event.target.value = this.f_number(0);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}

		if (event.target.value.toString() == item[columnName].toString()) {
			event.target.value = this.f_number(item[columnName]);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}

		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");

			if (Number(tmpValue) < min) tmpValue = min;

			if (!item[columnName]) {
				item[columnName] = tmpValue.toString();
			}

			if (tmpValue.toString().indexOf(',') == 0 && tmpValue.toString().length == 1) {
				tmpValue = min;
			}
			item[columnName] = tmpValue.toString();
		}
		else {
			item[columnName] = min.toString();
		}

		this.changeDetectView();
	}
	returnToPercent(inputNumber) {
		return inputNumber * 100;
	}
	roundNumber(input: number) {
		return Math.round(input)
	}
	/* -----------------------------------------------------------------------*/


	/*-------------------- HÀM HỖ TRỢ FORMAT DẠNG NGÀY -----------------------*/
	getFormatDate(v: string = '') {
		if (v != '' && v != null) {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	getFirstDay_LastDay(b_firstday) {
		var date = new Date(), y = date.getFullYear(), m = date.getMonth();
		var firstDay = new Date(y, m, 1);
		var lastDay = new Date(y, m + 1, 0);
		var curent = new Date();
		return b_firstday ? this.datePipe.transform(firstDay, 'dd/MM/yyyy') : this.datePipe.transform(curent, 'dd/MM/yyyy');
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------------ Extend Options --------------------------*/
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	scrollToBottom(){
		setTimeout(() => {
			let height = document.getElementById('dialog-form').scrollHeight
			document.getElementById('dialog-form').scrollTo({ top: height, behavior: 'smooth' });
		}, 200);
	}
	/* -----------------------------------------------------------------------*/
}
